import * as React from 'react';
import LoginForm from '@/screens/Login/components/LoginForm';

export interface ILoginProps {}

export default function Login() {
  return (
    <div
      className="flex h-full justify-end items-center  pr-5 sm:pr-20 bg-cover bg-center"
      style={{ backgroundImage: "url('/images/bg_login.jpg')" }}
    >
      <LoginForm />
    </div>
  );
}
